import angular from 'angular';
import uiRouter from 'angular-ui-router';
import subscription from '../subscription';
import account from '../account';
import ratePlan from '../rateplan';
import payment from '../payment';
import notification from '../notification';
import translation from '../translation';
import ngAnimate from 'angular-animate';
import clipboard from 'angular-clipboard';
import angularchartjs from 'angular-chart.js';
import ngSanitize from 'angular-sanitize';
import csvjs from 'ng-csv2';
import reactApp from '../reactAppLoader';
import controller from './controller';
import subscriptionController from './subscription.controller';
import routes from './routes';
import '../assets/src/sass/main.scss';

const app = angular.module('klCustomerCenter', [
  uiRouter,
  subscription,
  account,
  ratePlan,
  payment,
  notification,
  translation,
  ngAnimate,
  clipboard.name,
  angularchartjs,
  ngSanitize,
  csvjs,
  reactApp,
]);

controller(app);
subscriptionController(app);
routes(app);

export default app.name;
